module.exports = __webpack_public_path__ + "static/media/Tips_and_Tools-Improve_Speed.4224f8a3.svg";